import { createAction } from "@reduxjs/toolkit";
export const FETCH_DOMAIN_CALL_REPORT = 'FETCH_DOMAIN_CALL_REPORT';
export const fetchDomainCallReportAction = createAction(FETCH_DOMAIN_CALL_REPORT);